import { weekplannerDataPayload } from "../../Api/weekPlanner";
import {
  UPDATE_WEEK_PLANNER_FAILURE,
  UPDATE_WEEK_PLANNER_SUCCESS,
  UPDATE_WEEK_PLANNER_REQUEST,
  ADD_WEEK_PLANNER_FAILURE,
  ADD_WEEK_PLANNER_SUCCESS,
  ADD_WEEK_PLANNER_REQUEST
} from "../../Constants";

function addWeekPlannerRequest() {
  return {
    type: ADD_WEEK_PLANNER_REQUEST,
    isFetching: true
  };
}
function addWeekPlannerSuccess(data) {

  return {
    type: ADD_WEEK_PLANNER_SUCCESS,
    isFetching: false,
    data
  };
}
function addWeekPlannerfailure(data) {
  return {
    type: ADD_WEEK_PLANNER_FAILURE,
    isFetching: false,
    data
  };
}

function updateWeekPlannerRequest() {
  return {
    type: UPDATE_WEEK_PLANNER_REQUEST,
    isFetching: true
  };
}
function updateWeekPlannerSuccess(data) {
  return {
    type: UPDATE_WEEK_PLANNER_SUCCESS,
    isFetching: false,
    securityList: data
  };
}
function updateWeekPlannerfailure(data) {
  return {
    type: UPDATE_WEEK_PLANNER_FAILURE,
    isFetching: false,
    data
  };
}

//Add Week Planner
export const addWeekPlanner = payload => (dispatch, getState) => {
  dispatch(addWeekPlannerRequest());
  weekplannerDataPayload.weekPlannerData(payload)

    .then(res => {
      dispatch(addWeekPlannerSuccess(res));
    })
    .catch(err => dispatch(addWeekPlannerfailure(err)));
};

export const resetaddWeekPlanner = planner => (dispatch, getState) => {
  dispatch(addWeekPlannerSuccess(""));
};
//Update Week Planner
export const updateWeekPlanner = payload => (dispatch, getState) => {
  dispatch(updateWeekPlannerRequest());
  weekplannerDataPayload.weekPlannerData(payload)
    .then(res => {
      dispatch(updateWeekPlannerSuccess(res));
    })
    .catch(err => dispatch(updateWeekPlannerfailure(err)));
};
